var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardDebet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.47 27.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-3.39 -2.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.24,
    height: 32,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.24,27a1.22,1.22,0,0,1,.56.11,1.16,1.16,0,0,1,.39.31V25.65h.46v4.07h-.46v-.36a1.14,1.14,0,0,1-.39.3,1.38,1.38,0,0,1-.56.12,1.31,1.31,0,0,1-.52-.11,1.13,1.13,0,0,1-.43-.29,1.6,1.6,0,0,1-.29-.44,1.66,1.66,0,0,1,0-1.12,1.51,1.51,0,0,1,.29-.45,1.42,1.42,0,0,1,.43-.29A1.3,1.3,0,0,1,14.24,27Zm.06.43a1,1,0,0,0-.38.08.86.86,0,0,0-.29.21.73.73,0,0,0-.19.3,1,1,0,0,0-.07.38,1.16,1.16,0,0,0,.07.37.89.89,0,0,0,.19.31.86.86,0,0,0,.29.21.83.83,0,0,0,.38.07.79.79,0,0,0,.37-.07.84.84,0,0,0,.29-.2,1,1,0,0,0,.19-.31,1.1,1.1,0,0,0,0-.76.89.89,0,0,0-.19-.31.72.72,0,0,0-.29-.2A1,1,0,0,0,14.3,27.41ZM17.72,27a1.24,1.24,0,0,1,.5.1,1.06,1.06,0,0,1,.4.29,1,1,0,0,1,.26.44,1.54,1.54,0,0,1,.1.56v.17H16.86a1,1,0,0,0,.11.37,1,1,0,0,0,.2.26.76.76,0,0,0,.28.15.86.86,0,0,0,.32.05,1.12,1.12,0,0,0,.45-.08,1.36,1.36,0,0,0,.38-.24l.25.32-.26.2a1.11,1.11,0,0,1-.27.12l-.28.07-.29,0a1.45,1.45,0,0,1-.55-.1,1.17,1.17,0,0,1-.43-.29,1.4,1.4,0,0,1-.29-.44,1.71,1.71,0,0,1,0-1.14,1.57,1.57,0,0,1,.28-.44,1.42,1.42,0,0,1,.43-.29A1.35,1.35,0,0,1,17.72,27Zm0,.41a.87.87,0,0,0-.32.06.6.6,0,0,0-.25.16,1.08,1.08,0,0,0-.18.24.9.9,0,0,0-.09.32h1.64a.9.9,0,0,0-.09-.32.85.85,0,0,0-.17-.25.78.78,0,0,0-.24-.16,1,1,0,0,0-.3-.05ZM21.12,27a1.39,1.39,0,0,1,.53.1,1.37,1.37,0,0,1,.42.29,1.51,1.51,0,0,1,.29.45,1.55,1.55,0,0,1,0,1.12,1.6,1.6,0,0,1-.29.44,1.1,1.1,0,0,1-.42.29,1.4,1.4,0,0,1-.53.11,1.38,1.38,0,0,1-.56-.12,1.14,1.14,0,0,1-.39-.3v.36h-.46V25.65h.46v1.74a1.27,1.27,0,0,1,.39-.3A1.22,1.22,0,0,1,21.12,27Zm-.05.43a1,1,0,0,0-.38.08.72.72,0,0,0-.29.2.89.89,0,0,0-.19.31,1.1,1.1,0,0,0,0,.76,1,1,0,0,0,.19.31.88.88,0,0,0,.67.27.79.79,0,0,0,.37-.07,1,1,0,0,0,.3-.21.87.87,0,0,0,.18-.31.94.94,0,0,0,.07-.37,1,1,0,0,0-.07-.38.85.85,0,0,0-.19-.3.86.86,0,0,0-.29-.21A1,1,0,0,0,21.07,27.41Zm2.35-1.65a.3.3,0,0,1,.23.1.33.33,0,0,1,.1.23.31.31,0,0,1,0,.13.29.29,0,0,1-.17.17.32.32,0,0,1-.13,0,.27.27,0,0,1-.13,0l-.1-.07a.23.23,0,0,1-.07-.1.3.3,0,0,1,0-.26.23.23,0,0,1,.07-.1A.29.29,0,0,1,23.42,25.76Zm.23,4h-.46V27h.46Zm2.76-2.26H25.28v1.31a.82.82,0,0,0,0,.26.81.81,0,0,0,.1.18.54.54,0,0,0,.16.1.51.51,0,0,0,.21,0,.74.74,0,0,0,.29-.05.85.85,0,0,0,.25-.13l.22.35a1.7,1.7,0,0,1-.35.19,1.42,1.42,0,0,1-.45.08,1.23,1.23,0,0,1-.39-.06.8.8,0,0,1-.3-.19.87.87,0,0,1-.18-.31,1.14,1.14,0,0,1-.06-.45V27.46h-.58V27h.58v-.85h.46V27h1.13Z",
    transform: "translate(-3.39 -2.34)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.82,
    y: 2.15,
    width: 8.78,
    height: 15.78,
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,12.37a10,10,0,0,1,3.83-7.89,10,10,0,1,0,0,15.78,10,10,0,0,1-3.83-7.89",
    transform: "translate(-3.39 -2.34)",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9,18.59v-.32H35V18.2H34.7v.07h.13v.32Zm.64,0V18.2h-.1l-.11.27-.12-.27h-.1v.39h.07V18.3l.11.25h.07l.11-.25v.29Z",
    transform: "translate(-3.39 -2.34)",
    style: {
      fill: "#f79e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.82,2.34a10,10,0,0,0-6.2,2.14,10,10,0,0,1,1.69,14.09,9.65,9.65,0,0,1-1.69,1.69,10,10,0,1,0,6.2-17.92",
    transform: "translate(-3.39 -2.34)",
    style: {
      fill: "#f79e1b"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardDebet);
export default __webpack_public_path__ + "static/media/mastercard-debet.3f8c96a0.svg";
export { ForwardRef as ReactComponent };